var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.time.valid)?_vm._t("time",null,{"time":_vm.time}):_vm._t("end")],2)}
var staticRenderFns = []

export { render, staticRenderFns }